"use client";

import { createContext } from "react";
import { storedChoice } from "./stored-choice";

export const MIN_STAKES = [0, 100, 250, 500, 1000] as const;
export type MinStake = (typeof MIN_STAKES)[number];

export const MinStakeContext = createContext<MinStake>(0);

export function minStakeText(value: number): string {
  return `$${value.toLocaleString("en-US")}`;
}

export function belowMinText(value: number): string {
  return `No price meets your ${minStakeText(value)} minimum`;
}

export function parseMinStake(value: string | null): MinStake {
  return MIN_STAKES.find((option) => String(option) === value) ?? 0;
}

const useStoredMinStake = storedChoice<MinStake>("odds-screen:minStake", parseMinStake, 0);

export function useMinStake(): { minStake: MinStake; setMinStake: (next: MinStake) => void } {
  const [minStake, setMinStake] = useStoredMinStake();
  return { minStake, setMinStake };
}
